  <template >
   <div class="formPosition">
     <template>
  <v-container class="grey lighten-5">
    <v-row >
      <v-col md="4">
        <v-btn
         @click="addSumario"
          class="mx-2"
          fab
          dark
          color="primary"
        >
          <v-icon dark>add</v-icon>
        </v-btn>
        </v-col>
         <v-col md="4">
         <h3> <span> Súmarios publicados</span></h3>
        </v-col>
        </v-row >
  <div  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>
    <v-row no-gutters>
      <v-col >

                  <div class="flex-grow-1"></div>

<div class="text-center">

 <v-container fluid>

    <v-row>
        <v-col class="d-flex" cols="4" sm="5">
            <v-progress-linear v-if="progresso"
            color="green"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </v-col>

    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >

<v-row>
  <v-col md="6">
    <v-card-text>
      <strong> Súmario selecionado</strong>

    </v-card-text>
    <hr>
    <v-row>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Disciplina: {{(this.sumarioSelecionado.disciplina)}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Unidade: {{(this.sumarioSelecionado.unidade)}}</v-chip>
     </v-col>
    </v-row>
    <v-row>
     <v-col md="6">
          <v-chip style="margin:4px"><strong>Súmario: </strong>{{  this.sumarioSelecionado.sumario  }}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px; ">Aula: {{(this.sumarioSelecionado.aula)}}<strong></strong></v-chip>
     </v-col>
    </v-row>
        <v-container>
        <v-row>
        <v-col cols=12 >

    <div id="app">
        <ckeditor  :editor="editor" v-model="editorData" :config="editorConfig" :disabled="true"></ckeditor>
    </div>
     </v-col>
    </v-row>
    </v-container>

    <hr>
  </v-col>
  <v-col md="6">
    <v-card-text>
      <strong> {{titulo}}</strong>
    </v-card-text>
<v-dialog v-model="dialog" max-width="800px">

          <v-card>
            <v-card-title>
              <span class="headline">Editar Súmario </span>
                 <v-progress-circular
                    v-if="progressoDialog"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col  cols="12" sm="12" md="6">
                      <v-text-field
                   :disabled="true"
               v-model="sumarioSelecionado.disciplina"
                        label="Disciplina"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                      <v-text-field
                    v-model="sumarioSelecionado.unidade"
                        label="Unidade"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                       <v-text-field
         v-model="sumarioSelecionado.sumario"
                        label="Súmario"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                       <v-text-field
     v-model="sumarioSelecionado.aula"
                        label="Aula"
                      ></v-text-field>
                    </v-col>

                  </v-row>
                       <div id="app">
        <ckeditor  :editor="editor" v-model="editorData" :config="editorConfig" ></ckeditor>
    </div>

                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="
                  !(formValid) || progressoDialog
                "
                text
                @click="update"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row justify="center">
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
        <v-card-text>Essa operação é irreversivél, por isso pergunto novamente tens realmente a certeza de que desejas continuar com essa operação?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteSumario()">Concordar</v-btn>
          <v-btn color="green darken-1" text @click="dialogDelete=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
    <hr>
    <v-data-table

            :headers="headers"
            :items="this.sumarios"
            @click:row="sumarioselecionadoComClick"
          >
           <template v-slot:item.action="{ item }" >
<v-icon small class="mr-2" @click="editItem(item)" >edit</v-icon>
<v-icon small  @click="deleteItem(item)">delete</v-icon>
 </template>
      </v-data-table>

  </v-col>

</v-row>
  </v-card>

  </v-container>
</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties'
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties'
import Font from '@ckeditor/ckeditor5-font/src/font'
const ls = require('local-storage')
export default {
  name: 'app',
  data: () => ({
    eliminarSumario: [],
    formValid: true,
    valid: false,
    dialog: false,
    dialogDelete: false,
    progresso: false,
    sumarios: [],
    titulo: 'Súmarios publicados',
    progress: false,
    headers: [
      { text: 'Disciplina ', value: 'disciplina' },
      { text: 'Unidade', value: 'unidade' },
      { text: 'Súmario', value: 'sumario' },
      { text: 'Aula', value: 'aula' },
      { text: 'Actions', value: 'action', sortable: true }

    ],
    ruleRequired: [value => !!value || 'campo obrigatorio',
      value => {
        const pattern = /(([{0-9}]))$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    progressoDialog: false,
    sumarioSelecionado: {
      disciplina: '',
      controliddisciplina: 0,
      pkUnidade: 0,
      unidade: '',
      pkSumario: 0,
      sumario: '',
      pkAula: 0,
      aula: '',
      conteudo: '',
      anoacademico: 0
    },
    updateSumario: [],
    editor: ClassicEditor,
    editorData: '<div style="height:499px">Content of the editor.</div>',
    editorConfig: {
      plugins: [
        EssentialsPlugin,
        BoldPlugin,
        ItalicPlugin,
        LinkPlugin,
        ParagraphPlugin,
        Alignment,
        Table,
        TableToolbar,
        TableProperties,
        TableCellProperties,
        Font
      ],

      toolbar: {
        items: [
          'bold',
          'italic',
          'link',
          'undo',
          'redo',
          'alignment',
          'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells',
          'tableProperties', 'tableCellProperties',
          'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor'
        ]
      }
    }

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    window.location.href = 'http://aulas.softlineangola.com'
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        return true
      } else {
        return false
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    sumarioselecionadoComClick (teste) {
      this.sumarioSelecionado = teste
      this.valid = true
      this.editorData = this.sumarioSelecionado.conteudo
    },

    async  ListarSumarios () {
      this.progresso = true
      try {
        this.sumarios = await axios
          .get('/ListarSumarios')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {

      }
    },
    async  editItem (item) {
      this.sumarioSelecionado.conteudo = item.conteudo
      this.sumarioSelecionado.disciplina = item.disciplina
      this.sumarioSelecionado.controliddisciplina = item.controliddisciplina
      this.sumarioSelecionado.unidade = item.unidade
      this.sumarioSelecionado.pkUnidade = item.pkUnidade
      this.sumarioSelecionado.sumario = item.sumario
      this.sumarioSelecionado.pkSumario = item.pkSumario
      this.sumarioSelecionado.aula = item.aula
      this.sumarioSelecionado.pkAula = item.pkAula
      this.sumarioSelecionado.anoacademico = item.anoacademico
      this.dialog = true
    },
    deleteItem (item) {
      this.dialogDelete = true
    },
    close () {
      this.dialog = false
    },
    async deleteSumario () {
      this.progresso = true
      const valor = [{
        controliddisciplina: this.sumarioSelecionado.controliddisciplina,
        idUnidade: this.sumarioSelecionado.pkUnidade,
        idSumario: this.sumarioSelecionado.pkSumario,
        idAula: this.sumarioSelecionado.pkAula
      }]
      try {
        this.eliminarSumario = await axios
          .post('/deleteSumario', valor)
          .then(res => res.data)
        this.dialogDelete = false
        this.progresso = false
        this.ListarSumarios()
        this.sumarioSelecionado.disciplina = ''
        this.sumarioSelecionado.unidade = ''
        this.sumarioSelecionado.sumario = ''
        this.sumarioSelecionado.aula = ''
        this.editorData = '<div style="height:499px">Content of the editor.</div>'
        // Menssagem de sucesso da operação
        this.$store.dispatch('textMessage', { 'msg': 'Operação feita com sucesso', 'classMessage': 'msgSucess', 'timeout': 2000 })
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    // Update Súmario

    async update () {
      this.progresso = true
      const valor = [{
        controliddisciplina: this.sumarioSelecionado.controliddisciplina,
        idProfessor: ls.get('idPessoa'),
        unidadeDescricao: this.sumarioSelecionado.unidade,
        idUnidade: this.sumarioSelecionado.pkUnidade,
        sumarioDescricao: this.sumarioSelecionado.sumario,
        autor: ls.get('nomeUsuario'),
        idSumario: this.sumarioSelecionado.pkSumario,
        idAula: this.sumarioSelecionado.pkAula,
        aulaDescricao: this.sumarioSelecionado.aula,
        anoacademico: this.sumarioSelecionado.anoacademico,
        conteudo: this.editorData
      }]
      try {
        this.updateSumario = await axios
          .post('/insertSumario', valor)
          .then(res => res.data)
        this.progresso = false
        // Menssagem de sucesso da operação
        this.$store.dispatch('textMessage', { 'msg': 'Operação feita com sucesso', 'classMessage': 'msgSucess', 'timeout': 2000 })
        this.close()
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    addSumario () {
      this.$store.state.editorData = ` 
    <style>
    table {
        display: table;
        border-collapse: separate;
        box-sizing: border-box;
        border-spacing: 2px;
        border-color:blue   ;
        border:1px;
    }
    </style>
    
    <h1>Plano de aula</h1>
    
    
    <table >
      
      <tr>
       <td>
          <strong>Professor(a): </strong>
        Fulano de Tal <p/> 
       
        <strong> Disciplina: </strong>
         <p/>
         <strong>Classe: </strong> 
          Classe  
     </td>
        
      </tr>
      <tr>
        <td>
        
        <strong> Tema: </strong>
    O tema específico a ser desenvolvido nesta aula   
        
        </td>
        
      </tr>
      <tr>
        <td>
        
        <strong>
      OBJECTIVOS:</strong>
     a serem alcançados pelos alunos e não peloestagiário/professor;<p>
    <strong>Objectivo geral
    :</strong> projecta resultados relativos a execução de conteúdos e procedimentos.<p>
    <strong>Objectivos específicos</strong>
    :</strong> especificam resultados esperados e observáveis(geralmente de 3 a 4)
    
       </td>
        
      </tr>
      <tr>
        <td>
        
        <strong>
      Conteúdo:</strong>
     conteúdos programados para a aula organizados em tópicos (de 4ª8)
      
      </td>
        
      </tr>
       <tr>
        <td>
        
        <strong>
      Desenvolvimento do tema
    :</strong> descrição da abordagem teórica e pratica do tema(em anexo)VII.
      </td>
        
      </tr>
      <tr>
        <td>
        
        <strong>
    Recursos didácticos:</strong>
     (quadro, giz, retro-projector, etc.) e fontes histórico-escolares (Filme, musica, quadrinhos, etc)VIII.
     
      </td>
        
      </tr>
      <tr>
        <td>
        
        <strong>
    Observação ou avaliação:</strong>
     pode ser realizada com diferentes propósitos(diagnostica, formativa e somátiva). Discriminar, com base nos objectivos estabelecidos para aula:<p>
    <strong>Actividades</strong>
     (ex: respostas às perguntas - problema ao final da aula, discussãodo roteiro, compreensão de gravuras, trabalho com documentos, etc.Critérios adoptados para a correcção da actividade.IX.
     
      </td>
        
      </tr>
     
      <tr>
        <td>
        
        <strong>
    Bibliografia:</strong> indicar toda a bibliografia consultada para o planeamento da aula dividindo-a entre básica e complementar.
    
    </table
              `
      this.$router.push('/cadastrar-sumario')
    }

  }

}
</script>
<style >
.editor-box> * {
    border-color: grey;
    border-style: solid;
    border-width: 1px;
}

.is-active{
    border-color: grey;
    border-style: solid;
    border-width: 1px;
}
 /* *:focus {
    outline: none;
}  */
</style>
